import isEmpty from 'lodash/isEmpty';
import { VALUEDRIVER_OPTIONS } from '@model';
import { FORM_KEYS } from '@modules/insights/valueDriverManager/content/config/form.keys';

import { createActions } from 'redux-actions';
import { actionTypes } from './actionTypes';

import commonActions from './common';

import { API } from '../../service';

const {
  insights: { CHANGE_GD_PRINCIPLE_DATA, CHANGE_VALUE_DRIVER_MANAGE_DATA },
} = actionTypes;

const insightsActions = createActions(
  {},
  CHANGE_GD_PRINCIPLE_DATA,
  CHANGE_VALUE_DRIVER_MANAGE_DATA,
);

const fetchGdPrincipletData = (id, companyInstance) => async (dispatch) => {
  const data = await API.getGPrinciples(id, companyInstance);
  dispatch(
    insightsActions.changeGdPrincipleData({
      id,
      data: { principleData: data },
    }),
  );
};

const fetchGdPrincipleAndInsightstData =
  (id, companyInstance) => async (dispatch) => {
    dispatch(commonActions.changeLoading(true));
    const data = await API.getGPrinciplesAndInsightsRequest(
      id,
      companyInstance,
    );
    const { guidingPrincipleList = [], insightList = [] } = data || {};

    dispatch(
      insightsActions.changeGdPrincipleData({
        id,
        data: {
          principleData: guidingPrincipleList,
          insightsData: insightList,
        },
      }),
    );
    dispatch(commonActions.changeLoading(false));
  };

const fetchGdPrincipleDrawerData =
  (id, companyInstance) => async (dispatch) => {
    dispatch(commonActions.changeLoading(true));
    const data = await API.getGPrinciplesDrawerDataRequest(id, companyInstance);

    dispatch(
      insightsActions.changeGdPrincipleData({
        id,
        data: {
          principleDrawerData: isEmpty(data) ? [] : data,
        },
      }),
    );
    dispatch(commonActions.changeLoading(false));
  };

const updateGdPrincipleDrawerData =
  (body, projectId, companyInstance) => async (dispatch) => {
    const result = await API.updateGpDrawerData(
      body,
      projectId,
      companyInstance,
    );

    if (result) {
      await dispatch(fetchGdPrincipleDrawerData(projectId, companyInstance));

      return { success: true };
    }
  };

const deleteGdPrincipleDrawerData =
  (projectId, id, companyInstance) => async (dispatch) => {
    const result = await API.deleteGpDrawerData(id, projectId);

    if (result) {
      await dispatch(fetchGdPrincipleDrawerData(projectId, companyInstance));

      return { success: true };
    }
  };

const fetchOperatingModelData = (id) => async (dispatch) => {
  dispatch(commonActions.changeLoading(true));
  const data = await API.getOperatingModelRequest(id);

  dispatch(
    insightsActions.changeGdPrincipleData({
      id,
      data: { operatingModel: data },
    }),
  );
  dispatch(commonActions.changeLoading(false));
};

const updateOperatingModel = (body, projectId) => async (dispatch) => {
  const result = await API.updateAllOperatingModel(body, projectId);

  if (result) {
    await dispatch(fetchOperatingModelData(projectId));

    return { success: true };
  }
};

const handleDeletePrincipleInsight =
  ({ projectId, insightId, field, companyInstance }) =>
  async (dispatch) => {
    const result = await API.deleteInsightRequest(insightId, field);

    if (result) {
      await dispatch(fetchGdPrincipletData(projectId, companyInstance));
    }
    return { success: true };
  };

const handleSavePrincipleInsight = (body) => async (dispatch) => {
  const result = await API.editOrAddInsight(body);

  if (result) {
    await dispatch(
      fetchGdPrincipleAndInsightstData(body.projectId, body.companyInstance),
    );

    return { success: true };
  }
};
const changeOrderAndRefetch =
  (type, insightsIdArr) => async (dispatch, getState) => {
    dispatch(commonActions.changeLoading(true));
    await API.reOrderInsights(getState().common.currentId, type, insightsIdArr);
    dispatch(commonActions.changeLoading(false));
  };

const saveValueDriver = (formData) => async (dispatch, getState) => {
  const projectId = getState().common.currentId;
  const resp = await API.saveValueDriverRequest({
    projectId,
    params: formData,
  });
  return { success: Boolean(resp?.message) };
};

const fetchValueDriverManageData = () => async (dispatch, getState) => {
  dispatch(commonActions.changeLoading(true));
  const projectId = getState().common.currentId;

  const response = await API.getValueDriverManageDataRequest({ projectId });

  const data = formatValueDriverManageData(response);

  dispatch(insightsActions.changeValueDriverManageData(data));
  dispatch(commonActions.changeLoading(false));
};

const formatValueDriverManageData = (data = {}) => {
  try {
    const dataTemp = { ...data };
    const listKey = FORM_KEYS.TABLE_WRAPPER.key;

    dataTemp[listKey] = (dataTemp[listKey] || []).map((i) =>
      formatValueDriverManageListData(i, dataTemp.format),
    );

    return dataTemp;
  } catch (error) {
    return data;
  }
};

const handleDollarValue = (value, format) => {
  if (value === null || value === '') {
    return null;
  }
  const result = Number.parseInt(value) / format;
  return !Number.isNaN(result)
    ? String(result).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    : value;
};

export const formatValueDriverManageListData = (data, format = 1) => {
  const typeKey = FORM_KEYS.TYPE.key;
  const synergyKey = FORM_KEYS.SYNERGY.key;
  const oneTimeCostKey = FORM_KEYS.ONE_TIME_COST.key;
  const financialImpactKey = FORM_KEYS.FINANCIAL_IMPACT.key;

  // const categoryKey = FORM_KEYS.key;

  data[typeKey] = getOptionValue(typeKey, data[typeKey]);

  data[synergyKey] = getOptionValue(
    synergyKey,
    data[synergyKey],
    data[typeKey],
  );

  data[oneTimeCostKey] =
    data[`${oneTimeCostKey}OfScale`] ||
    handleDollarValue(data[`${oneTimeCostKey}OfDollarValue`], format);
  data[financialImpactKey] =
    data[`${financialImpactKey}OfScale`] ||
    handleDollarValue(data[`${financialImpactKey}OfDollarValue`], format);

  // data[categoryKey] = getOptionValue(
  //   categoryKey,
  //   data[categoryKey],
  //   `${data[typeKey]}-${data[synergyKey]}`,
  // );

  return data;
};

const getOptionValue = (key, label, father = '') => {
  const options = VALUEDRIVER_OPTIONS[key];

  if (!Array.isArray(options)) {
    return label;
  }

  const matchedOpt = options.find(
    (opt) => opt.label === label && opt.value.startsWith(father),
  );
  return matchedOpt?.value || label;
};

const updateAllGuidingPrinciples =
  (body, projectId, companyInstance) => async (dispatch) => {
    const result = await API.updateAllGuidingPrinciples(
      body,
      projectId,
      companyInstance,
    );

    if (result) {
      await dispatch(
        fetchGdPrincipleAndInsightstData(projectId, companyInstance),
      );
      await dispatch(fetchGdPrincipleDrawerData(projectId, companyInstance));

      return { success: true };
    }
  };

export default {
  ...insightsActions,
  fetchGdPrincipletData,
  handleDeletePrincipleInsight,
  handleSavePrincipleInsight,
  fetchGdPrincipleAndInsightstData,
  fetchGdPrincipleDrawerData,
  updateGdPrincipleDrawerData,
  deleteGdPrincipleDrawerData,
  fetchOperatingModelData,
  changeOrderAndRefetch,
  saveValueDriver,
  fetchValueDriverManageData,
  updateAllGuidingPrinciples,
  updateOperatingModel,
};
